const RETRY_DELAY_MS = 500

// iOS Safari intermittently rejects dynamic imports ("Importing a module script failed.") when a request is cut short,
// e.g. while the tab is backgrounded. WebKit re-fetches on a second import() of the same URL, so one retry recovers it.
// Chromium caches the failed import and rejects the retry without a request, so this only helps WebKit.
export async function importWithRetry<T>(load: () => Promise<T>): Promise<T> {
  try {
    return await load()
  } catch {
    await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS))
    return load()
  }
}
